import gql from 'graphql-tag'
import client from 'lib/graphql'
import { MFA_STATUS_QUERY } from './status'

export const SETUP_SMS_MUTATION = gql`
  mutation app__MfaSetupSms($input: SetupSmsInput!) {
    setupSms(input: $input) {
      userId
      recoveryCode
      errors {
        message
      }
    }
  }
`

export const SEND_SMS_QUERY = gql`
  query app__MfaSendSms {
    sendSms {
      userId
      success
      lastFour
      errors {
        message
      }
    }
  }
`

export const VERIFY_SMS_QUERY = gql`
  query app__MfaVerifySms($input: VerifySmsInput!) {
    verifySms(input: $input) {
      userId
      success
      errors {
        message
      }
    }
  }
`

export const DISABLE_SMS_MUTATION = gql`
  mutation app__MfaDisableSms($input: DisableSmsInput!) {
    disableSms(input: $input) {
      userId
      errors {
        message
      }
    }
  }
`

type DisableSmsMutation = DisableSmsPayload | null

interface DisableSmsPayload {
  userId: string | null
  errors: ValidationError[] | null
}

interface ValidationError {
  message: string
}

export async function disableSms(password: string): Promise<DisableSmsMutation> {
  const { data } = await client.mutate({
    mutation: DISABLE_SMS_MUTATION,
    variables: {
      input: {
        password
      }
    },
    refetchQueries: [{ query: MFA_STATUS_QUERY }]
  })

  return data.disableSms
}
